export const isArraysEqual = (arr1, arr2) => JSON.stringify(arr1) === JSON.stringify(arr2);
export const uint8ToArray = uint8Arr => Array.from(uint8Arr);
